import { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { themr } from '../react-css-themr'
import { PROGRESS_BAR } from '../identifiers'
import prefixer from '../utils/prefixer'

class ProgressBar extends Component {
  static propTypes = {
    buffer: PropTypes.number,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number,
    mode: PropTypes.oneOf(['determinate', 'indeterminate']),
    multicolor: PropTypes.bool,
    theme: PropTypes.shape({
      buffer: PropTypes.string,
      circle: PropTypes.string,
      circular: PropTypes.string,
      indeterminate: PropTypes.string,
      linear: PropTypes.string,
      multicolor: PropTypes.string,
      path: PropTypes.string,
      value: PropTypes.string,
    }),
    type: PropTypes.oneOf(['linear', 'circular']),
    value: PropTypes.number,
  }

  calculateRatio(value) {
    const { min = 0, max = 100 } = this.props
    if (value < min) return 0
    if (value > max) return 1
    return (value - min) / (max - min)
  }

  circularStyle() {
    const { mode = 'indeterminate', value = 0 } = this.props
    return mode !== 'indeterminate'
      ? {
          strokeDasharray: `${2 * Math.PI * 25 * this.calculateRatio(value)}, 400`,
        }
      : undefined
  }

  linearStyle() {
    const { mode = 'indeterminate', buffer = 0, value = 0 } = this.props
    if (mode !== 'indeterminate') {
      return {
        buffer: prefixer({
          transform: `scaleX(${this.calculateRatio(buffer)})`,
        }),
        value: prefixer({
          transform: `scaleX(${this.calculateRatio(value)})`,
        }),
      }
    }
    return {}
  }

  renderCircular() {
    return (
      <svg className={this.props.theme.circle} viewBox='0 0 60 60'>
        <circle
          className={this.props.theme.path}
          style={this.circularStyle()}
          cx='30'
          cy='30'
          r='25'
        />
      </svg>
    )
  }

  renderLinear() {
    const { buffer, value } = this.linearStyle()
    return (
      <div>
        <span data-ref='buffer' className={this.props.theme.buffer} style={buffer} />
        <span data-ref='value' className={this.props.theme.value} style={value} />
      </div>
    )
  }

  render() {
    const {
      className = '',
      disabled,
      max = 100,
      min = 0,
      mode = 'indeterminate',
      multicolor = false,
      type = 'linear',
      theme,
      value = 0,
      buffer = 0, // eslint-disable-line no-unused-vars
    } = this.props
    const _className = cx(
      theme[type],
      {
        [theme.indeterminate]: mode === 'indeterminate',
        [theme.multicolor]: multicolor,
      },
      className
    )

    return (
      <div
        disabled={disabled}
        data-react-toolbox='progress-bar'
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        className={_className}>
        {type === 'circular' ? this.renderCircular() : this.renderLinear()}
      </div>
    )
  }
}

export default themr(PROGRESS_BAR)(ProgressBar)
export { ProgressBar }
